import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { IgenomicsState } from "@ispm/core/interfaces/genomics-state.interface";
import { IRevision } from "@ispm/workflow/interfaces/revision.interface";
import { selectActiveRevision } from "@ispm/workflow/store/workflow-config.selectors";
import { take } from "rxjs/operators";

@Injectable()
export class FloatingPanelService {
  constructor(private store: Store<IgenomicsState>) {
  }

  getActiveWorkflowRevision(): Promise<IRevision> {
    return this.store.select(selectActiveRevision).pipe(take(1)).toPromise();
  }
}
